import { LetterState, LetterType, RecordProcessState } from '@coin/shared/core/util-enums';

const PROCESS_STATE_ORDER: string[] = Object.values(RecordProcessState);

interface RecordPlanChangeCandidate {
  processState?: string | null;
  recordLetterStates?: { letterType?: string | null; state?: string | null }[] | null;
}

/** Mirrors the backend AdjustRecord guard: a plan change is rejected once the TAF is created unless no TAF is required. */
export function canChangeRecordPlan(record: RecordPlanChangeCandidate): boolean {
  const processStateIndex = PROCESS_STATE_ORDER.indexOf(record.processState);
  if (processStateIndex >= PROCESS_STATE_ORDER.indexOf(RecordProcessState.Frozen)) {
    return false;
  }
  if (processStateIndex <= PROCESS_STATE_ORDER.indexOf(RecordProcessState.TafCreated)) {
    return true;
  }
  return (
    record.recordLetterStates?.some(
      letterState =>
        letterState.letterType === LetterType.TargetAgreementForm && letterState.state === LetterState.NoLetterRequired
    ) ?? false
  );
}
